import { render, staticRenderFns } from "./mine_menu.vue?vue&type=template&id=aead50ca&lang=pug&"
import script from "./mine_menu.vue?vue&type=script&lang=js&"
export * from "./mine_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports